// extracted by mini-css-extract-plugin
export default {"wrapper":"Register__wrapper___gOIQy","or":"Register__or___2dyPR","checkbox":"Register__checkbox___3NOfn"};